import React, { createContext, useContext, useState, useMemo } from 'react';
import { translations } from '../utils/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const t = useMemo(() => {
    return (key) => {
      const keys = key.split('.');
      let value = translations[language];
      
      for (const k of keys) {
        value = value?.[k];
      }
      
      return value || key;
    };
  }, [language]); // language is the only external dependency; keys, k, value are internal

  const toggleLanguage = useMemo(() => {
    return () => {
      setLanguage(prev => prev === 'en' ? 'bg' : 'en');
    };
  }, [setLanguage]);

  // Memoize context value to prevent unnecessary re-renders
  const contextValue = useMemo(() => ({
    language,
    setLanguage,
    t,
    toggleLanguage
  }), [language, t, toggleLanguage]);

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
